/* Céla — micro-interactions (thème v15)
   En-tête, rail produits.
   v15 : plus aucun effet lié au défilement (apparitions, mots qui s'éclairent, parallaxe).
   Le contenu est visible tout de suite et la page défile de façon fluide,
   sans calcul à chaque image pendant le défilement. */
(function () {
  'use strict';
  window.luxOK = true;

  var doc = document.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  doc.classList.add('lux-js');

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* ---------- En-tête : état au défilement (une seule classe, calculée au plus une fois par image) ---------- */
  function initHeader() {
    var main = document.getElementById('MainContent');
    if (main && main.getAttribute('data-template') === 'index') document.body.classList.add('lux-home');
    var ticking = false;
    var scrolled = null;
    function update() {
      ticking = false;
      var now = window.scrollY > 40;
      if (now !== scrolled) {
        scrolled = now;
        document.body.classList.toggle('lux-scrolled', now);
      }
    }
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      },
      { passive: true }
    );
    update();
  }

  /* ---------- Contenu visible immédiatement ---------- */
  function showAll(scope) {
    (scope || document).querySelectorAll('[data-lux-reveal], [data-lux-lines], [data-zz]').forEach(function (el) {
      el.classList.add('is-in');
    });
  }

  /* ---------- Rail de produits (flèches + glisser) ---------- */
  function initRails(scope) {
    (scope || document).querySelectorAll('[data-lux-rail]').forEach(function (wrap) {
      if (wrap.dataset.luxRailDone) return;
      wrap.dataset.luxRailDone = '1';
      var track = wrap.querySelector('[data-lux-rail-track]');
      var prev = wrap.querySelector('[data-lux-rail-prev]');
      var next = wrap.querySelector('[data-lux-rail-next]');
      var bar = wrap.querySelector('[data-lux-rail-progress]');
      if (!track) return;
      function step() {
        var item = track.firstElementChild;
        return item ? item.getBoundingClientRect().width + 24 : track.clientWidth * 0.8;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        var p = max > 0 ? track.scrollLeft / max : 0;
        if (bar) bar.style.transform = 'scaleX(' + Math.max(0.08, p).toFixed(3) + ')';
        if (prev) prev.disabled = track.scrollLeft < 4;
        if (next) next.disabled = track.scrollLeft > max - 4;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduced ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduced ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      // Glisser à la souris
      var down = false, startX = 0, startLeft = 0, moved = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = true;
        moved = false;
        startX = e.clientX;
        startLeft = track.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4) {
          moved = true;
          track.classList.add('is-dragging');
        }
        track.scrollLeft = startLeft - dx;
      });
      window.addEventListener('pointerup', function () {
        down = false;
        track.classList.remove('is-dragging');
      });
      track.addEventListener('click', function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      }, true);
      update();
    });
  }

  function initAll(scope) {
    showAll(scope);
    initRails(scope);
  }

  ready(function () {
    initHeader();
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
